module.exports = __webpack_public_path__ + "img/Nut.1863b7b2.svg";